import { Grid } from 'jrgrid';
import { pageEOneUpdates, pageRequestedItems } from '../api';
import Navbar from '../../../components/Navbar';
import { eOneColumns, filterButtonsEOne, reqEoneReadyColumns } from '../utils';
import React from 'react';
import { Loader } from '../../../components/Loader';
import { Button, Col, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';

export const RequestEOneReadyPage = (props: any) => {
  const [refresh, setRefresh] = React.useState(false);
  const { user } = useSelector((state: any) => ({
    user: state.user,
  }));

  const renderEOneErrorsGrid = () => {
    if (refresh) {
      setTimeout(() => {
        setRefresh(false);
      }, 500);
      return <Loader title='Reloading Grid..' />;
    } else {
      // let filter = [];
      const filter = [
        {
          id: 'status',
          type: 'string',
          operand: 'and',
          isLike: false,
          value: 'Ready for EOne',
        },
        {
          id: 'department',
          type: 'string',
          operand: 'and',
          isLike: false,
          value: `${user.currentRole.departmentAbbreviation}`,
        },
      ];

      return (
        <Grid
          amount={20}
          columns={reqEoneReadyColumns}
          query={pageRequestedItems}
          queryName='pageRequestedItems'
          defaultSortField='requestedItemId'
          globalFilters={/* gridFilter ? [gridFilter, ...filter] : [...filter] */ filter}
        />
      );
    }
  };

  return (
    <div>
      <Navbar />
      <div className='container-fluid'>
        <Row>
          <Col md={8}>
            {/* {filterButtonsEOne.map((item, index) => {
              return (
                <Button
                  key={index}
                  className='mt-3 mb-3 ml-2'
                  onClick={() => {
                    setGridFilter(item.filter);
                  }}>
                  {item.title}
                </Button>
              );
            })} */}
          </Col>
          <Col md={4}>
            <h3 className='mt-3 mb-3 ml-2 mr-2 float-right'>Request Items Ready for EOne</h3>
          </Col>
        </Row>
        {renderEOneErrorsGrid()}
      </div>
    </div>
  );
};
